import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useState
} from 'react'

import { ApiConfig } from '../types'

type ApiContextType = {
  apiData: ApiConfig
  updateApiConfig?: (newConfig: ApiConfig) => void
}

const ApiContext = createContext<ApiContextType | undefined>(undefined)

export const ApiProvider = ({ children }: PropsWithChildren) => {
  const [api, setApi] = useState<ApiConfig>({
    tokens: {
      access: '',
      saas: ''
    },
    baseUrl: ''
  })

  const updateApiConfig = useCallback((newConfig: ApiConfig) => {
    setApi((prevApi) => ({ ...prevApi, ...newConfig }))
  }, [])

  return (
    <ApiContext.Provider value={{ apiData: api, updateApiConfig }}>
      {children}
    </ApiContext.Provider>
  )
}

export const useApi = () => {
  const context = useContext(ApiContext)
  if (!context) {
    throw new Error('useApi must be used within an ApiProvider')
  }
  return context
}
